// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable plugin/no-unused-selectors */
/* stylelint-disable no-descending-specificity */
.z1bjoUSvJd2OG5 {
  position: relative;
  min-height: 36px;
  border-radius: var(--ds-border-radius-200, 8px);
  background-color: var(--ds-surface-raised, #ffffff);
  box-shadow: var(--ds-shadow-raised, 0px 1px 1px #091e4240, 0px 0px 1px #091e424f);
  color: var(--ds-text, #172b4d);
  cursor: pointer;
  scroll-margin: var(--ds-space-100, 8px);
}
.z1bjoUSvJd2OG5:focus-within {
  outline: var(--ds-border-focused, #388bff) auto 2px;
  outline-offset: 2px;
  opacity: 1;
}
.mac .z1bjoUSvJd2OG5:focus-within {
  outline-color: -webkit-focus-ring-color;
}
.z1bjoUSvJd2OG5:focus-within .mac.firefox {
  outline-color: AccentColor;
}
.safari .z1bjoUSvJd2OG5:focus-within {
  outline-style: solid;
}
.z1bjoUSvJd2OG5:has([data-testid='card-front-board-hint']) {
  margin-bottom: 5px;
}
.z1bjoUSvJd2OG5.sxr_P5X6VqfFZO {
  background-color: var(--ds-background-information, #e9f2ff);
}
.LEoComdwwB5SiQ:not(:hover, :focus-within, [data-drag-preview]) {
  background-color: transparent;
  box-shadow: none;
}
.vec996bH3vs0JC {
  display: none;
  position: absolute;
  z-index: 10;
  top: var(--ds-space-025, 2px);
  right: var(--ds-space-025, 2px);
  /* stylelint-disable-next-line selector-max-type */
}
.z1bjoUSvJd2OG5:hover .vec996bH3vs0JC,
.z1bjoUSvJd2OG5:focus-within .vec996bH3vs0JC,
.Jo7UM37A_dXNgy {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.z1bjoUSvJd2OG5[data-drag-preview] .vec996bH3vs0JC {
  /* stylelint-disable-next-line declaration-no-important */
  display: none !important;
}
@media (prefers-reduced-motion: reduce) {
  .kCaocI3DJaoQ38 .Xi7bNymQFppyCy {
    transition: none;
    opacity: 1;
  }
  .kCaocI3DJaoQ38 .OZOw_0q9XfR1sR {
    width: calc(100% - 20px);
    transform: translateX(0px);
    transition: none;
  }
}
@media (prefers-reduced-motion: no-preference) {
  .kCaocI3DJaoQ38 .Xi7bNymQFppyCy {
    transition: opacity 0.3s ease-in;
    opacity: 0;
  }
  .kCaocI3DJaoQ38 .Xi7bNymQFppyCy:focus-visible {
    transition: opacity 0.3s ease-in;
    opacity: 1;
  }
  .kCaocI3DJaoQ38 .OZOw_0q9XfR1sR {
    width: 100%;
    transform: translateX(-20px);
    transition: all 0.3s ease-in;
  }
  .z1bjoUSvJd2OG5:hover .kCaocI3DJaoQ38 .Xi7bNymQFppyCy,
  .z1bjoUSvJd2OG5:focus-within .kCaocI3DJaoQ38 .Xi7bNymQFppyCy,
  .lOLxSkx78RAs6K .Xi7bNymQFppyCy {
    transition: opacity 0.3s ease-in;
    opacity: 1;
  }
  .z1bjoUSvJd2OG5:hover .kCaocI3DJaoQ38 .OZOw_0q9XfR1sR,
  .z1bjoUSvJd2OG5:focus-within .kCaocI3DJaoQ38 .OZOw_0q9XfR1sR,
  .lOLxSkx78RAs6K .OZOw_0q9XfR1sR {
    width: calc(100% - 20px);
    transform: translateX(0px);
    transition: transform 0.3s ease-in;
  }
}
`, ""]);
// Exports
export var cardFront = `z1bjoUSvJd2OG5`;
export var pinned = `sxr_P5X6VqfFZO`;
var _1 = `LEoComdwwB5SiQ`;
export { _1 as "cardFront--separator" };
export var cardFrontActions = `vec996bH3vs0JC`;
var _2 = `Jo7UM37A_dXNgy`;
export { _2 as "cardFrontActions--isCardActive" };
export var cardFrontAnimateDoneState = `kCaocI3DJaoQ38`;
export var buttonAnimation = `Xi7bNymQFppyCy`;
export var cardTitleAnimation = `OZOw_0q9XfR1sR`;
var _3 = `lOLxSkx78RAs6K`;
export { _3 as "cardFrontAnimateDoneState--isCardActive" };
export default ___CSS_LOADER_EXPORT___;
